"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var common_pb_exports = {};
__export(common_pb_exports, {
  AppEnvironment: () => AppEnvironment,
  Chain: () => Chain,
  ChainIdentifier: () => ChainIdentifier,
  CommitmentLevel: () => CommitmentLevel,
  Money: () => Money,
  MoneyUnit: () => MoneyUnit,
  Network: () => Network,
  NetworkIdentifier: () => NetworkIdentifier,
  NodeImpl: () => NodeImpl,
  NodeState: () => NodeState,
  NodeType: () => NodeType,
  SortDirection: () => SortDirection
});
module.exports = __toCommonJS(common_pb_exports);
var import_protobuf = require("@bufbuild/protobuf");
var Chain = /* @__PURE__ */ ((Chain2) => {
  Chain2[Chain2["CHAIN_UNSPECIFIED"] = 0] = "CHAIN_UNSPECIFIED";
  Chain2[Chain2["ETH"] = 1] = "ETH";
  Chain2[Chain2["CRO"] = 2] = "CRO";
  Chain2[Chain2["ARB"] = 3] = "ARB";
  Chain2[Chain2["FLOW"] = 4] = "FLOW";
  Chain2[Chain2["MATIC"] = 5] = "MATIC";
  Chain2[Chain2["OPT"] = 6] = "OPT";
  Chain2[Chain2["SOLANA"] = 8] = "SOLANA";
  Chain2[Chain2["ASTAR"] = 9] = "ASTAR";
  Chain2[Chain2["POLYGONZKEVM"] = 10] = "POLYGONZKEVM";
  Chain2[Chain2["STARKNET"] = 11] = "STARKNET";
  Chain2[Chain2["BASE"] = 12] = "BASE";
  Chain2[Chain2["ZKSYNC"] = 13] = "ZKSYNC";
  Chain2[Chain2["ZORA"] = 14] = "ZORA";
  Chain2[Chain2["FRAX"] = 15] = "FRAX";
  Chain2[Chain2["BNB"] = 16] = "BNB";
  Chain2[Chain2["AVAX"] = 17] = "AVAX";
  Chain2[Chain2["ARBNOVA"] = 18] = "ARBNOVA";
  Chain2[Chain2["ALCHEMY"] = 19] = "ALCHEMY";
  Chain2[Chain2["WORLDCHAIN"] = 20] = "WORLDCHAIN";
  Chain2[Chain2["ZETACHAIN"] = 21] = "ZETACHAIN";
  Chain2[Chain2["BLAST"] = 22] = "BLAST";
  Chain2[Chain2["SCROLL"] = 23] = "SCROLL";
  Chain2[Chain2["LINEA"] = 24] = "LINEA";
  Chain2[Chain2["GNOSIS"] = 25] = "GNOSIS";
  Chain2[Chain2["FANTOM"] = 26] = "FANTOM";
  Chain2[Chain2["MANTLE"] = 27] = "MANTLE";
  Chain2[Chain2["CELO"] = 28] = "CELO";
  Chain2[Chain2["BERACHAIN"] = 29] = "BERACHAIN";
  Chain2[Chain2["METIS"] = 30] = "METIS";
  Chain2[Chain2["OPBNB"] = 31] = "OPBNB";
  Chain2[Chain2["POLYNOMIAL"] = 32] = "POLYNOMIAL";
  Chain2[Chain2["SHAPE"] = 33] = "SHAPE";
  Chain2[Chain2["BOB"] = 34] = "BOB";
  Chain2[Chain2["CROSSFI"] = 35] = "CROSSFI";
  Chain2[Chain2["IOTA"] = 36] = "IOTA";
  Chain2[Chain2["MODE"] = 37] = "MODE";
  Chain2[Chain2["MOONBASE"] = 38] = "MOONBASE";
  Chain2[Chain2["MOONBEAM"] = 39] = "MOONBEAM";
  Chain2[Chain2["MOONRIVER"] = 40] = "MOONRIVER";
  Chain2[Chain2["PALM"] = 41] = "PALM";
  Chain2[Chain2["SHIDEN"] = 42] = "SHIDEN";
  Chain2[Chain2["SEI"] = 43] = "SEI";
  Chain2[Chain2["KINTO"] = 44] = "KINTO";
  Chain2[Chain2["PLUME"] = 45] = "PLUME";
  Chain2[Chain2["ANIME"] = 46] = "ANIME";
  Chain2[Chain2["RACE"] = 47] = "RACE";
  Chain2[Chain2["APECHAIN"] = 48] = "APECHAIN";
  Chain2[Chain2["APEX"] = 49] = "APEX";
  Chain2[Chain2["BOSS"] = 50] = "BOSS";
  Chain2[Chain2["LENS"] = 51] = "LENS";
  Chain2[Chain2["SONEIUM"] = 52] = "SONEIUM";
  Chain2[Chain2["GEIST"] = 53] = "GEIST";
  Chain2[Chain2["SOCIALNETWORK"] = 54] = "SOCIALNETWORK";
  Chain2[Chain2["ALCHEMYARB"] = 56] = "ALCHEMYARB";
  Chain2[Chain2["ROOTSTOCK"] = 57] = "ROOTSTOCK";
  Chain2[Chain2["LUMIA"] = 58] = "LUMIA";
  Chain2[Chain2["UNICHAIN"] = 59] = "UNICHAIN";
  Chain2[Chain2["SONIC"] = 60] = "SONIC";
  Chain2[Chain2["SPOTLIGHT"] = 61] = "SPOTLIGHT";
  Chain2[Chain2["XMTP"] = 62] = "XMTP";
  Chain2[Chain2["CHILIZ"] = 63] = "CHILIZ";
  Chain2[Chain2["ABSTRACT"] = 64] = "ABSTRACT";
  Chain2[Chain2["K2"] = 65] = "K2";
  Chain2[Chain2["METABASED"] = 66] = "METABASED";
  Chain2[Chain2["MONAD"] = 67] = "MONAD";
  Chain2[Chain2["SUPERSEED"] = 68] = "SUPERSEED";
  Chain2[Chain2["DEGEN"] = 69] = "DEGEN";
  Chain2[Chain2["UNITE"] = 70] = "UNITE";
  Chain2[Chain2["SETTLUS"] = 71] = "SETTLUS";
  Chain2[Chain2["INK"] = 72] = "INK";
  Chain2[Chain2["ODYSSEY"] = 73] = "ODYSSEY";
  Chain2[Chain2["RONIN"] = 74] = "RONIN";
  Chain2[Chain2["STANDARD"] = 75] = "STANDARD";
  Chain2[Chain2["METABASED2"] = 76] = "METABASED2";
  Chain2[Chain2["SYNDICATE"] = 77] = "SYNDICATE";
  Chain2[Chain2["HUMANITY"] = 78] = "HUMANITY";
  Chain2[Chain2["XPROTOCOL"] = 79] = "XPROTOCOL";
  Chain2[Chain2["SPARKPOINT"] = 80] = "SPARKPOINT";
  Chain2[Chain2["ALTERSCOPE"] = 81] = "ALTERSCOPE";
  Chain2[Chain2["TEA"] = 82] = "TEA";
  Chain2[Chain2["GENSYN"] = 83] = "GENSYN";
  Chain2[Chain2["OPENLOOT"] = 84] = "OPENLOOT";
  Chain2[Chain2["RISE"] = 85] = "RISE";
  Chain2[Chain2["BITCOIN"] = 86] = "BITCOIN";
  Chain2[Chain2["MARS"] = 87] = "MARS";
  Chain2[Chain2["EARNM"] = 88] = "EARNM";
  Chain2[Chain2["STORY"] = 89] = "STORY";
  Chain2[Chain2["WYLERCHAIN"] = 90] = "WYLERCHAIN";
  Chain2[Chain2["MEGAETH"] = 91] = "MEGAETH";
  Chain2[Chain2["APTOS"] = 92] = "APTOS";
  Chain2[Chain2["SUI"] = 93] = "SUI";
  Chain2[Chain2["WORLDMOBILE"] = 94] = "WORLDMOBILE";
  Chain2[Chain2["CONVERGE"] = 95] = "CONVERGE";
  Chain2[Chain2["GALACTICA"] = 96] = "GALACTICA";
  Chain2[Chain2["NEXUS"] = 97] = "NEXUS";
  Chain2[Chain2["BOTANIX"] = 98] = "BOTANIX";
  Chain2[Chain2["WORLDMOBILECHAIN"] = 99] = "WORLDMOBILECHAIN";
  Chain2[Chain2["HYPERLIQUID"] = 100] = "HYPERLIQUID";
  return Chain2;
})(Chain || {});
import_protobuf.proto3.util.setEnumType(Chain, "alchemy.common.Chain", [
  { no: 0, name: "CHAIN_UNSPECIFIED" },
  { no: 1, name: "ETH" },
  { no: 2, name: "CRO" },
  { no: 3, name: "ARB" },
  { no: 4, name: "FLOW" },
  { no: 5, name: "MATIC" },
  { no: 6, name: "OPT" },
  { no: 8, name: "SOLANA" },
  { no: 9, name: "ASTAR" },
  { no: 10, name: "POLYGONZKEVM" },
  { no: 11, name: "STARKNET" },
  { no: 12, name: "BASE" },
  { no: 13, name: "ZKSYNC" },
  { no: 14, name: "ZORA" },
  { no: 15, name: "FRAX" },
  { no: 16, name: "BNB" },
  { no: 17, name: "AVAX" },
  { no: 18, name: "ARBNOVA" },
  { no: 19, name: "ALCHEMY" },
  { no: 20, name: "WORLDCHAIN" },
  { no: 21, name: "ZETACHAIN" },
  { no: 22, name: "BLAST" },
  { no: 23, name: "SCROLL" },
  { no: 24, name: "LINEA" },
  { no: 25, name: "GNOSIS" },
  { no: 26, name: "FANTOM" },
  { no: 27, name: "MANTLE" },
  { no: 28, name: "CELO" },
  { no: 29, name: "BERACHAIN" },
  { no: 30, name: "METIS" },
  { no: 31, name: "OPBNB" },
  { no: 32, name: "POLYNOMIAL" },
  { no: 33, name: "SHAPE" },
  { no: 34, name: "BOB" },
  { no: 35, name: "CROSSFI" },
  { no: 36, name: "IOTA" },
  { no: 37, name: "MODE" },
  { no: 38, name: "MOONBASE" },
  { no: 39, name: "MOONBEAM" },
  { no: 40, name: "MOONRIVER" },
  { no: 41, name: "PALM" },
  { no: 42, name: "SHIDEN" },
  { no: 43, name: "SEI" },
  { no: 44, name: "KINTO" },
  { no: 45, name: "PLUME" },
  { no: 46, name: "ANIME" },
  { no: 47, name: "RACE" },
  { no: 48, name: "APECHAIN" },
  { no: 49, name: "APEX" },
  { no: 50, name: "BOSS" },
  { no: 51, name: "LENS" },
  { no: 52, name: "SONEIUM" },
  { no: 53, name: "GEIST" },
  { no: 54, name: "SOCIALNETWORK" },
  { no: 56, name: "ALCHEMYARB" },
  { no: 57, name: "ROOTSTOCK" },
  { no: 58, name: "LUMIA" },
  { no: 59, name: "UNICHAIN" },
  { no: 60, name: "SONIC" },
  { no: 61, name: "SPOTLIGHT" },
  { no: 62, name: "XMTP" },
  { no: 63, name: "CHILIZ" },
  { no: 64, name: "ABSTRACT" },
  { no: 65, name: "K2" },
  { no: 66, name: "METABASED" },
  { no: 67, name: "MONAD" },
  { no: 68, name: "SUPERSEED" },
  { no: 69, name: "DEGEN" },
  { no: 70, name: "UNITE" },
  { no: 71, name: "SETTLUS" },
  { no: 72, name: "INK" },
  { no: 73, name: "ODYSSEY" },
  { no: 74, name: "RONIN" },
  { no: 75, name: "STANDARD" },
  { no: 76, name: "METABASED2" },
  { no: 77, name: "SYNDICATE" },
  { no: 78, name: "HUMANITY" },
  { no: 79, name: "XPROTOCOL" },
  { no: 80, name: "SPARKPOINT" },
  { no: 81, name: "ALTERSCOPE" },
  { no: 82, name: "TEA" },
  { no: 83, name: "GENSYN" },
  { no: 84, name: "OPENLOOT" },
  { no: 85, name: "RISE" },
  { no: 86, name: "BITCOIN" },
  { no: 87, name: "MARS" },
  { no: 88, name: "EARNM" },
  { no: 89, name: "STORY" },
  { no: 90, name: "WYLERCHAIN" },
  { no: 91, name: "MEGAETH" },
  { no: 92, name: "APTOS" },
  { no: 93, name: "SUI" },
  { no: 94, name: "WORLDMOBILE" },
  { no: 95, name: "CONVERGE" },
  { no: 96, name: "GALACTICA" },
  { no: 97, name: "NEXUS" },
  { no: 98, name: "BOTANIX" },
  { no: 99, name: "WORLDMOBILECHAIN" },
  { no: 100, name: "HYPERLIQUID" }
]);
var CommitmentLevel = /* @__PURE__ */ ((CommitmentLevel2) => {
  CommitmentLevel2[CommitmentLevel2["COMMITMENT_LEVEL_UNSPECIFIED"] = 0] = "COMMITMENT_LEVEL_UNSPECIFIED";
  CommitmentLevel2[CommitmentLevel2["LATEST"] = 1] = "LATEST";
  CommitmentLevel2[CommitmentLevel2["SAFE"] = 2] = "SAFE";
  CommitmentLevel2[CommitmentLevel2["FINALIZED"] = 3] = "FINALIZED";
  CommitmentLevel2[CommitmentLevel2["CONFIRMED"] = 4] = "CONFIRMED";
  CommitmentLevel2[CommitmentLevel2["PROCESSED"] = 5] = "PROCESSED";
  CommitmentLevel2[CommitmentLevel2["COMMITTED"] = 6] = "COMMITTED";
  return CommitmentLevel2;
})(CommitmentLevel || {});
import_protobuf.proto3.util.setEnumType(CommitmentLevel, "alchemy.common.CommitmentLevel", [
  { no: 0, name: "COMMITMENT_LEVEL_UNSPECIFIED" },
  { no: 1, name: "LATEST" },
  { no: 2, name: "SAFE" },
  { no: 3, name: "FINALIZED" },
  { no: 4, name: "CONFIRMED" },
  { no: 5, name: "PROCESSED" },
  { no: 6, name: "COMMITTED" }
]);
var Network = /* @__PURE__ */ ((Network2) => {
  Network2[Network2["NETWORK_UNSPECIFIED"] = 0] = "NETWORK_UNSPECIFIED";
  Network2[Network2["ETH_MAINNET"] = 1] = "ETH_MAINNET";
  Network2[Network2["ETH_ROPSTEN"] = 2] = "ETH_ROPSTEN";
  Network2[Network2["ETH_RINKEBY"] = 3] = "ETH_RINKEBY";
  Network2[Network2["ETH_KOVAN"] = 4] = "ETH_KOVAN";
  Network2[Network2["ETH_GOERLI"] = 5] = "ETH_GOERLI";
  Network2[Network2["ETH_SEPOLIA"] = 6] = "ETH_SEPOLIA";
  Network2[Network2["ETH_HOLESKY"] = 7] = "ETH_HOLESKY";
  Network2[Network2["ETH_MEKONG"] = 8] = "ETH_MEKONG";
  Network2[Network2["ETH_HOODI"] = 9] = "ETH_HOODI";
  Network2[Network2["ETH_MAINNETBEACON"] = 51] = "ETH_MAINNETBEACON";
  Network2[Network2["ETH_SEPOLIABEACON"] = 56] = "ETH_SEPOLIABEACON";
  Network2[Network2["ETH_HOLESKYBEACON"] = 57] = "ETH_HOLESKYBEACON";
  Network2[Network2["ETH_HOODIBEACON"] = 59] = "ETH_HOODIBEACON";
  Network2[Network2["CRO_MAINNET"] = 100] = "CRO_MAINNET";
  Network2[Network2["CRO_CROESEID"] = 101] = "CRO_CROESEID";
  Network2[Network2["ARB_MAINNET"] = 201] = "ARB_MAINNET";
  Network2[Network2["ARB_RINKEBY"] = 203] = "ARB_RINKEBY";
  Network2[Network2["ARB_GOERLI"] = 205] = "ARB_GOERLI";
  Network2[Network2["ARB_SEPOLIA"] = 206] = "ARB_SEPOLIA";
  Network2[Network2["FLOW_MAINNET"] = 300] = "FLOW_MAINNET";
  Network2[Network2["FLOW_TESTNET"] = 301] = "FLOW_TESTNET";
  Network2[Network2["MATIC_MAINNET"] = 401] = "MATIC_MAINNET";
  Network2[Network2["MATIC_MUMBAI"] = 406] = "MATIC_MUMBAI";
  Network2[Network2["MATIC_AMOY"] = 407] = "MATIC_AMOY";
  Network2[Network2["OPT_MAINNET"] = 501] = "OPT_MAINNET";
  Network2[Network2["OPT_KOVAN"] = 504] = "OPT_KOVAN";
  Network2[Network2["OPT_GOERLI"] = 505] = "OPT_GOERLI";
  Network2[Network2["OPT_SEPOLIA"] = 506] = "OPT_SEPOLIA";
  Network2[Network2["SOLANA_MAINNET"] = 701] = "SOLANA_MAINNET";
  Network2[Network2["SOLANA_TESTNET"] = 702] = "SOLANA_TESTNET";
  Network2[Network2["SOLANA_DEVNET"] = 703] = "SOLANA_DEVNET";
  Network2[Network2["ASTAR_MAINNET"] = 801] = "ASTAR_MAINNET";
  Network2[Network2["ASTAR_SHIDEN"] = 802] = "ASTAR_SHIDEN";
  Network2[Network2["ASTAR_SHIBUYA"] = 803] = "ASTAR_SHIBUYA";
  Network2[Network2["POLYGONZKEVM_MAINNET"] = 901] = "POLYGONZKEVM_MAINNET";
  Network2[Network2["POLYGONZKEVM_TESTNET"] = 902] = "POLYGONZKEVM_TESTNET";
  Network2[Network2["POLYGONZKEVM_CARDONA"] = 903] = "POLYGONZKEVM_CARDONA";
  Network2[Network2["STARKNET_MAINNET"] = 1001] = "STARKNET_MAINNET";
  Network2[Network2["STARKNET_GOERLI"] = 1002] = "STARKNET_GOERLI";
  Network2[Network2["STARKNET_SEPOLIA"] = 1003] = "STARKNET_SEPOLIA";
  Network2[Network2["BASE_MAINNET"] = 1101] = "BASE_MAINNET";
  Network2[Network2["BASE_GOERLI"] = 1102] = "BASE_GOERLI";
  Network2[Network2["BASE_SEPOLIA"] = 1103] = "BASE_SEPOLIA";
  Network2[Network2["ZKSYNC_MAINNET"] = 1201] = "ZKSYNC_MAINNET";
  Network2[Network2["ZKSYNC_SEPOLIA"] = 1202] = "ZKSYNC_SEPOLIA";
  Network2[Network2["ZORA_MAINNET"] = 1301] = "ZORA_MAINNET";
  Network2[Network2["ZORA_SEPOLIA"] = 1302] = "ZORA_SEPOLIA";
  Network2[Network2["FRAX_MAINNET"] = 1401] = "FRAX_MAINNET";
  Network2[Network2["FRAX_SEPOLIA"] = 1402] = "FRAX_SEPOLIA";
  Network2[Network2["BNB_MAINNET"] = 1501] = "BNB_MAINNET";
  Network2[Network2["BNB_TESTNET"] = 1502] = "BNB_TESTNET";
  Network2[Network2["AVAX_MAINNET"] = 1601] = "AVAX_MAINNET";
  Network2[Network2["AVAX_FUJI"] = 1602] = "AVAX_FUJI";
  Network2[Network2["ARBNOVA_MAINNET"] = 1701] = "ARBNOVA_MAINNET";
  Network2[Network2["ALCHEMY_MAINNET"] = 1801] = "ALCHEMY_MAINNET";
  Network2[Network2["ALCHEMY_SEPOLIA"] = 1802] = "ALCHEMY_SEPOLIA";
  Network2[Network2["ALCHEMY_INTERNAL"] = 1803] = "ALCHEMY_INTERNAL";
  Network2[Network2["WORLDCHAIN_MAINNET"] = 1901] = "WORLDCHAIN_MAINNET";
  Network2[Network2["WORLDCHAIN_SEPOLIA"] = 1902] = "WORLDCHAIN_SEPOLIA";
  Network2[Network2["ZETACHAIN_MAINNET"] = 2001] = "ZETACHAIN_MAINNET";
  Network2[Network2["ZETACHAIN_TESTNET"] = 2002] = "ZETACHAIN_TESTNET";
  Network2[Network2["BLAST_MAINNET"] = 2101] = "BLAST_MAINNET";
  Network2[Network2["BLAST_SEPOLIA"] = 2102] = "BLAST_SEPOLIA";
  Network2[Network2["SCROLL_MAINNET"] = 2201] = "SCROLL_MAINNET";
  Network2[Network2["SCROLL_SEPOLIA"] = 2202] = "SCROLL_SEPOLIA";
  Network2[Network2["LINEA_MAINNET"] = 2301] = "LINEA_MAINNET";
  Network2[Network2["LINEA_SEPOLIA"] = 2302] = "LINEA_SEPOLIA";
  Network2[Network2["GNOSIS_MAINNET"] = 2401] = "GNOSIS_MAINNET";
  Network2[Network2["GNOSIS_CHIADO"] = 2402] = "GNOSIS_CHIADO";
  Network2[Network2["FANTOM_MAINNET"] = 2501] = "FANTOM_MAINNET";
  Network2[Network2["FANTOM_TESTNET"] = 2502] = "FANTOM_TESTNET";
  Network2[Network2["MANTLE_MAINNET"] = 2601] = "MANTLE_MAINNET";
  Network2[Network2["MANTLE_SEPOLIA"] = 2602] = "MANTLE_SEPOLIA";
  Network2[Network2["CELO_MAINNET"] = 2701] = "CELO_MAINNET";
  Network2[Network2["CELO_ALFAJORES"] = 2702] = "CELO_ALFAJORES";
  Network2[Network2["CELO_BAKLAVA"] = 2703] = "CELO_BAKLAVA";
  Network2[Network2["BERACHAIN_ARTIO"] = 2801] = "BERACHAIN_ARTIO";
  Network2[Network2["BERACHAIN_BARTIO"] = 2802] = "BERACHAIN_BARTIO";
  Network2[Network2["BERACHAIN_MAINNET"] = 2803] = "BERACHAIN_MAINNET";
  Network2[Network2["BERACHAIN_BEPOLIA"] = 2804] = "BERACHAIN_BEPOLIA";
  Network2[Network2["METIS_MAINNET"] = 2901] = "METIS_MAINNET";
  Network2[Network2["OPBNB_MAINNET"] = 3001] = "OPBNB_MAINNET";
  Network2[Network2["OPBNB_TESTNET"] = 3002] = "OPBNB_TESTNET";
  Network2[Network2["POLYNOMIAL_MAINNET"] = 3101] = "POLYNOMIAL_MAINNET";
  Network2[Network2["POLYNOMIAL_SEPOLIA"] = 3102] = "POLYNOMIAL_SEPOLIA";
  Network2[Network2["SHAPE_MAINNET"] = 3201] = "SHAPE_MAINNET";
  Network2[Network2["SHAPE_SEPOLIA"] = 3202] = "SHAPE_SEPOLIA";
  Network2[Network2["BOB_MAINNET"] = 3301] = "BOB_MAINNET";
  Network2[Network2["BOB_SEPOLIA"] = 3302] = "BOB_SEPOLIA";
  Network2[Network2["CROSSFI_TESTNET"] = 3401] = "CROSSFI_TESTNET";
  Network2[Network2["CROSSFI_MAINNET"] = 3402] = "CROSSFI_MAINNET";
  Network2[Network2["IOTA_MAINNET"] = 3501] = "IOTA_MAINNET";
  Network2[Network2["IOTA_TESTNET"] = 3502] = "IOTA_TESTNET";
  Network2[Network2["MODE_MAINNET"] = 3601] = "MODE_MAINNET";
  Network2[Network2["MODE_SEPOLIA"] = 3602] = "MODE_SEPOLIA";
  Network2[Network2["MOONBASE_ALPHA"] = 3701] = "MOONBASE_ALPHA";
  Network2[Network2["MOONBEAM_MAINNET"] = 3801] = "MOONBEAM_MAINNET";
  Network2[Network2["MOONRIVER_MAINNET"] = 3901] = "MOONRIVER_MAINNET";
  Network2[Network2["PALM_MAINNET"] = 4001] = "PALM_MAINNET";
  Network2[Network2["PALM_TESTNET"] = 4002] = "PALM_TESTNET";
  Network2[Network2["SHIDEN_MAINNET"] = 4101] = "SHIDEN_MAINNET";
  Network2[Network2["SHIDEN_SHIBUYA"] = 4102] = "SHIDEN_SHIBUYA";
  Network2[Network2["SEI_MAINNET"] = 4201] = "SEI_MAINNET";
  Network2[Network2["SEI_TESTNET"] = 4202] = "SEI_TESTNET";
  Network2[Network2["KINTO_MAINNET"] = 4301] = "KINTO_MAINNET";
  Network2[Network2["PLUME_TESTNET"] = 4402] = "PLUME_TESTNET";
  Network2[Network2["ANIME_MAINNET"] = 4501] = "ANIME_MAINNET";
  Network2[Network2["ANIME_SEPOLIA"] = 4502] = "ANIME_SEPOLIA";
  Network2[Network2["RACE_MAINNET"] = 4601] = "RACE_MAINNET";
  Network2[Network2["RACE_SEPOLIA"] = 4602] = "RACE_SEPOLIA";
  Network2[Network2["APECHAIN_MAINNET"] = 4701] = "APECHAIN_MAINNET";
  Network2[Network2["APECHAIN_CURTIS"] = 4702] = "APECHAIN_CURTIS";
  Network2[Network2["APEX_MAINNET"] = 4801] = "APEX_MAINNET";
  Network2[Network2["BOSS_MAINNET"] = 4901] = "BOSS_MAINNET";
  Network2[Network2["LENS_MAINNET"] = 5001] = "LENS_MAINNET";
  Network2[Network2["LENS_SEPOLIA"] = 5002] = "LENS_SEPOLIA";
  Network2[Network2["SONEIUM_MAINNET"] = 5101] = "SONEIUM_MAINNET";
  Network2[Network2["SONEIUM_MINATO"] = 5102] = "SONEIUM_MINATO";
  Network2[Network2["GEIST_MAINNET"] = 5201] = "GEIST_MAINNET";
  Network2[Network2["GEIST_POLTER"] = 5202] = "GEIST_POLTER";
  Network2[Network2["SOCIALNETWORK_TESTNET"] = 5301] = "SOCIALNETWORK_TESTNET";
  Network2[Network2["SOCIALNETWORK_MAINNET"] = 5302] = "SOCIALNETWORK_MAINNET";
  Network2[Network2["ALCHEMYARB_FAM"] = 5501] = "ALCHEMYARB_FAM";
  Network2[Network2["ALCHEMYARB_SEPOLIA"] = 5502] = "ALCHEMYARB_SEPOLIA";
  Network2[Network2["ROOTSTOCK_MAINNET"] = 5601] = "ROOTSTOCK_MAINNET";
  Network2[Network2["ROOTSTOCK_TESTNET"] = 5602] = "ROOTSTOCK_TESTNET";
  Network2[Network2["LUMIA_PRISM"] = 5701] = "LUMIA_PRISM";
  Network2[Network2["LUMIA_TESTNET"] = 5702] = "LUMIA_TESTNET";
  Network2[Network2["UNICHAIN_MAINNET"] = 5801] = "UNICHAIN_MAINNET";
  Network2[Network2["UNICHAIN_SEPOLIA"] = 5802] = "UNICHAIN_SEPOLIA";
  Network2[Network2["SONIC_MAINNET"] = 5901] = "SONIC_MAINNET";
  Network2[Network2["SONIC_TESTNET"] = 5902] = "SONIC_TESTNET";
  Network2[Network2["SONIC_BLAZE"] = 5903] = "SONIC_BLAZE";
  Network2[Network2["SPOTLIGHT_SEPOLIA"] = 6001] = "SPOTLIGHT_SEPOLIA";
  Network2[Network2["SPOTLIGHT_MAINNET"] = 6002] = "SPOTLIGHT_MAINNET";
  Network2[Network2["XMTP_TESTNET"] = 6101] = "XMTP_TESTNET";
  Network2[Network2["CHILIZ_MAINNET"] = 6201] = "CHILIZ_MAINNET";
  Network2[Network2["CHILIZ_SPICY"] = 6202] = "CHILIZ_SPICY";
  Network2[Network2["ABSTRACT_MAINNET"] = 6301] = "ABSTRACT_MAINNET";
  Network2[Network2["ABSTRACT_TESTNET"] = 6302] = "ABSTRACT_TESTNET";
  Network2[Network2["K2_TESTNET"] = 6401] = "K2_TESTNET";
  Network2[Network2["METABASED_STRATOS"] = 6501] = "METABASED_STRATOS";
  Network2[Network2["MONAD_TESTNET"] = 6602] = "MONAD_TESTNET";
  Network2[Network2["SUPERSEED_MAINNET"] = 6701] = "SUPERSEED_MAINNET";
  Network2[Network2["SUPERSEED_SEPOLIA"] = 6702] = "SUPERSEED_SEPOLIA";
  Network2[Network2["DEGEN_MAINNET"] = 6801] = "DEGEN_MAINNET";
  Network2[Network2["DEGEN_SEPOLIA"] = 6802] = "DEGEN_SEPOLIA";
  Network2[Network2["UNITE_MAINNET"] = 6901] = "UNITE_MAINNET";
  Network2[Network2["UNITE_TESTNET"] = 6902] = "UNITE_TESTNET";
  Network2[Network2["SETTLUS_MAINNET"] = 7001] = "SETTLUS_MAINNET";
  Network2[Network2["SETTLUS_SEPTESTNET"] = 7002] = "SETTLUS_SEPTESTNET";
  Network2[Network2["INK_MAINNET"] = 7101] = "INK_MAINNET";
  Network2[Network2["INK_SEPOLIA"] = 7102] = "INK_SEPOLIA";
  Network2[Network2["ODYSSEY_SEPOLIA"] = 7201] = "ODYSSEY_SEPOLIA";
  Network2[Network2["RONIN_MAINNET"] = 7301] = "RONIN_MAINNET";
  Network2[Network2["RONIN_SAIGON"] = 7302] = "RONIN_SAIGON";
  Network2[Network2["STANDARD_MAINNET"] = 7401] = "STANDARD_MAINNET";
  Network2[Network2["STANDARD_TESTNET"] = 7402] = "STANDARD_TESTNET";
  Network2[Network2["METABASED2_EXO"] = 7501] = "METABASED2_EXO";
  Network2[Network2["SYNDICATE_EXO"] = 7601] = "SYNDICATE_EXO";
  Network2[Network2["SYNDICATE_MANCHEGO"] = 7602] = "SYNDICATE_MANCHEGO";
  Network2[Network2["HUMANITY_MAINNET"] = 7701] = "HUMANITY_MAINNET";
  Network2[Network2["HUMANITY_TESTNET"] = 7702] = "HUMANITY_TESTNET";
  Network2[Network2["XPROTOCOL_MAINNET"] = 7801] = "XPROTOCOL_MAINNET";
  Network2[Network2["XPROTOCOL_SEPOLIA"] = 7802] = "XPROTOCOL_SEPOLIA";
  Network2[Network2["SPARKPOINT_MAINNET"] = 7901] = "SPARKPOINT_MAINNET";
  Network2[Network2["SPARKPOINT_TESTNET"] = 7902] = "SPARKPOINT_TESTNET";
  Network2[Network2["ALTERSCOPE_MAINNET"] = 8001] = "ALTERSCOPE_MAINNET";
  Network2[Network2["ALTERSCOPE_SEPOLIA"] = 8002] = "ALTERSCOPE_SEPOLIA";
  Network2[Network2["TEA_MAINNET"] = 8101] = "TEA_MAINNET";
  Network2[Network2["TEA_SEPOLIA"] = 8102] = "TEA_SEPOLIA";
  Network2[Network2["GENSYN_TESTNET"] = 8201] = "GENSYN_TESTNET";
  Network2[Network2["OPENLOOT_SEPOLIA"] = 8301] = "OPENLOOT_SEPOLIA";
  Network2[Network2["RISE_TESTNET"] = 8402] = "RISE_TESTNET";
  Network2[Network2["BITCOIN_MAINNET"] = 8501] = "BITCOIN_MAINNET";
  Network2[Network2["BITCOIN_TESTNET"] = 8502] = "BITCOIN_TESTNET";
  Network2[Network2["BITCOIN_SIGNET"] = 8503] = "BITCOIN_SIGNET";
  Network2[Network2["MARS_TESTNET"] = 8601] = "MARS_TESTNET";
  Network2[Network2["EARNM_SEPOLIA"] = 8701] = "EARNM_SEPOLIA";
  Network2[Network2["STORY_MAINNET"] = 8801] = "STORY_MAINNET";
  Network2[Network2["STORY_AENEID"] = 8802] = "STORY_AENEID";
  Network2[Network2["WYLERCHAIN_SEPOLIA"] = 8901] = "WYLERCHAIN_SEPOLIA";
  Network2[Network2["MEGAETH_TESTNET"] = 9002] = "MEGAETH_TESTNET";
  Network2[Network2["APTOS_MAINNET"] = 9101] = "APTOS_MAINNET";
  Network2[Network2["APTOS_TESTNET"] = 9102] = "APTOS_TESTNET";
  Network2[Network2["SUI_MAINNET"] = 9201] = "SUI_MAINNET";
  Network2[Network2["SUI_TESTNET"] = 9202] = "SUI_TESTNET";
  Network2[Network2["WORLDMOBILE_DEVNET"] = 9302] = "WORLDMOBILE_DEVNET";
  Network2[Network2["WORLDMOBILE_TESTNET"] = 9303] = "WORLDMOBILE_TESTNET";
  Network2[Network2["CONVERGE_TESTNET"] = 9402] = "CONVERGE_TESTNET";
  Network2[Network2["GALACTICA_CASSIOPEIA"] = 9502] = "GALACTICA_CASSIOPEIA";
  Network2[Network2["NEXUS_SEPOLIA"] = 9602] = "NEXUS_SEPOLIA";
  Network2[Network2["BOTANIX_MAINNET"] = 9701] = "BOTANIX_MAINNET";
  Network2[Network2["BOTANIX_TESTNET"] = 9702] = "BOTANIX_TESTNET";
  Network2[Network2["WORLDMOBILECHAIN_MAINNET"] = 9801] = "WORLDMOBILECHAIN_MAINNET";
  Network2[Network2["HYPERLIQUID_MAINNET"] = 9901] = "HYPERLIQUID_MAINNET";
  return Network2;
})(Network || {});
import_protobuf.proto3.util.setEnumType(Network, "alchemy.common.Network", [
  { no: 0, name: "NETWORK_UNSPECIFIED" },
  { no: 1, name: "ETH_MAINNET" },
  { no: 2, name: "ETH_ROPSTEN" },
  { no: 3, name: "ETH_RINKEBY" },
  { no: 4, name: "ETH_KOVAN" },
  { no: 5, name: "ETH_GOERLI" },
  { no: 6, name: "ETH_SEPOLIA" },
  { no: 7, name: "ETH_HOLESKY" },
  { no: 8, name: "ETH_MEKONG" },
  { no: 9, name: "ETH_HOODI" },
  { no: 51, name: "ETH_MAINNETBEACON" },
  { no: 56, name: "ETH_SEPOLIABEACON" },
  { no: 57, name: "ETH_HOLESKYBEACON" },
  { no: 59, name: "ETH_HOODIBEACON" },
  { no: 100, name: "CRO_MAINNET" },
  { no: 101, name: "CRO_CROESEID" },
  { no: 201, name: "ARB_MAINNET" },
  { no: 203, name: "ARB_RINKEBY" },
  { no: 205, name: "ARB_GOERLI" },
  { no: 206, name: "ARB_SEPOLIA" },
  { no: 300, name: "FLOW_MAINNET" },
  { no: 301, name: "FLOW_TESTNET" },
  { no: 401, name: "MATIC_MAINNET" },
  { no: 406, name: "MATIC_MUMBAI" },
  { no: 407, name: "MATIC_AMOY" },
  { no: 501, name: "OPT_MAINNET" },
  { no: 504, name: "OPT_KOVAN" },
  { no: 505, name: "OPT_GOERLI" },
  { no: 506, name: "OPT_SEPOLIA" },
  { no: 701, name: "SOLANA_MAINNET" },
  { no: 702, name: "SOLANA_TESTNET" },
  { no: 703, name: "SOLANA_DEVNET" },
  { no: 801, name: "ASTAR_MAINNET" },
  { no: 802, name: "ASTAR_SHIDEN" },
  { no: 803, name: "ASTAR_SHIBUYA" },
  { no: 901, name: "POLYGONZKEVM_MAINNET" },
  { no: 902, name: "POLYGONZKEVM_TESTNET" },
  { no: 903, name: "POLYGONZKEVM_CARDONA" },
  { no: 1001, name: "STARKNET_MAINNET" },
  { no: 1002, name: "STARKNET_GOERLI" },
  { no: 1003, name: "STARKNET_SEPOLIA" },
  { no: 1101, name: "BASE_MAINNET" },
  { no: 1102, name: "BASE_GOERLI" },
  { no: 1103, name: "BASE_SEPOLIA" },
  { no: 1201, name: "ZKSYNC_MAINNET" },
  { no: 1202, name: "ZKSYNC_SEPOLIA" },
  { no: 1301, name: "ZORA_MAINNET" },
  { no: 1302, name: "ZORA_SEPOLIA" },
  { no: 1401, name: "FRAX_MAINNET" },
  { no: 1402, name: "FRAX_SEPOLIA" },
  { no: 1501, name: "BNB_MAINNET" },
  { no: 1502, name: "BNB_TESTNET" },
  { no: 1601, name: "AVAX_MAINNET" },
  { no: 1602, name: "AVAX_FUJI" },
  { no: 1701, name: "ARBNOVA_MAINNET" },
  { no: 1801, name: "ALCHEMY_MAINNET" },
  { no: 1802, name: "ALCHEMY_SEPOLIA" },
  { no: 1803, name: "ALCHEMY_INTERNAL" },
  { no: 1901, name: "WORLDCHAIN_MAINNET" },
  { no: 1902, name: "WORLDCHAIN_SEPOLIA" },
  { no: 2001, name: "ZETACHAIN_MAINNET" },
  { no: 2002, name: "ZETACHAIN_TESTNET" },
  { no: 2101, name: "BLAST_MAINNET" },
  { no: 2102, name: "BLAST_SEPOLIA" },
  { no: 2201, name: "SCROLL_MAINNET" },
  { no: 2202, name: "SCROLL_SEPOLIA" },
  { no: 2301, name: "LINEA_MAINNET" },
  { no: 2302, name: "LINEA_SEPOLIA" },
  { no: 2401, name: "GNOSIS_MAINNET" },
  { no: 2402, name: "GNOSIS_CHIADO" },
  { no: 2501, name: "FANTOM_MAINNET" },
  { no: 2502, name: "FANTOM_TESTNET" },
  { no: 2601, name: "MANTLE_MAINNET" },
  { no: 2602, name: "MANTLE_SEPOLIA" },
  { no: 2701, name: "CELO_MAINNET" },
  { no: 2702, name: "CELO_ALFAJORES" },
  { no: 2703, name: "CELO_BAKLAVA" },
  { no: 2801, name: "BERACHAIN_ARTIO" },
  { no: 2802, name: "BERACHAIN_BARTIO" },
  { no: 2803, name: "BERACHAIN_MAINNET" },
  { no: 2804, name: "BERACHAIN_BEPOLIA" },
  { no: 2901, name: "METIS_MAINNET" },
  { no: 3001, name: "OPBNB_MAINNET" },
  { no: 3002, name: "OPBNB_TESTNET" },
  { no: 3101, name: "POLYNOMIAL_MAINNET" },
  { no: 3102, name: "POLYNOMIAL_SEPOLIA" },
  { no: 3201, name: "SHAPE_MAINNET" },
  { no: 3202, name: "SHAPE_SEPOLIA" },
  { no: 3301, name: "BOB_MAINNET" },
  { no: 3302, name: "BOB_SEPOLIA" },
  { no: 3401, name: "CROSSFI_TESTNET" },
  { no: 3402, name: "CROSSFI_MAINNET" },
  { no: 3501, name: "IOTA_MAINNET" },
  { no: 3502, name: "IOTA_TESTNET" },
  { no: 3601, name: "MODE_MAINNET" },
  { no: 3602, name: "MODE_SEPOLIA" },
  { no: 3701, name: "MOONBASE_ALPHA" },
  { no: 3801, name: "MOONBEAM_MAINNET" },
  { no: 3901, name: "MOONRIVER_MAINNET" },
  { no: 4001, name: "PALM_MAINNET" },
  { no: 4002, name: "PALM_TESTNET" },
  { no: 4101, name: "SHIDEN_MAINNET" },
  { no: 4102, name: "SHIDEN_SHIBUYA" },
  { no: 4201, name: "SEI_MAINNET" },
  { no: 4202, name: "SEI_TESTNET" },
  { no: 4301, name: "KINTO_MAINNET" },
  { no: 4402, name: "PLUME_TESTNET" },
  { no: 4501, name: "ANIME_MAINNET" },
  { no: 4502, name: "ANIME_SEPOLIA" },
  { no: 4601, name: "RACE_MAINNET" },
  { no: 4602, name: "RACE_SEPOLIA" },
  { no: 4701, name: "APECHAIN_MAINNET" },
  { no: 4702, name: "APECHAIN_CURTIS" },
  { no: 4801, name: "APEX_MAINNET" },
  { no: 4901, name: "BOSS_MAINNET" },
  { no: 5001, name: "LENS_MAINNET" },
  { no: 5002, name: "LENS_SEPOLIA" },
  { no: 5101, name: "SONEIUM_MAINNET" },
  { no: 5102, name: "SONEIUM_MINATO" },
  { no: 5201, name: "GEIST_MAINNET" },
  { no: 5202, name: "GEIST_POLTER" },
  { no: 5301, name: "SOCIALNETWORK_TESTNET" },
  { no: 5302, name: "SOCIALNETWORK_MAINNET" },
  { no: 5501, name: "ALCHEMYARB_FAM" },
  { no: 5502, name: "ALCHEMYARB_SEPOLIA" },
  { no: 5601, name: "ROOTSTOCK_MAINNET" },
  { no: 5602, name: "ROOTSTOCK_TESTNET" },
  { no: 5701, name: "LUMIA_PRISM" },
  { no: 5702, name: "LUMIA_TESTNET" },
  { no: 5801, name: "UNICHAIN_MAINNET" },
  { no: 5802, name: "UNICHAIN_SEPOLIA" },
  { no: 5901, name: "SONIC_MAINNET" },
  { no: 5902, name: "SONIC_TESTNET" },
  { no: 5903, name: "SONIC_BLAZE" },
  { no: 6001, name: "SPOTLIGHT_SEPOLIA" },
  { no: 6002, name: "SPOTLIGHT_MAINNET" },
  { no: 6101, name: "XMTP_TESTNET" },
  { no: 6201, name: "CHILIZ_MAINNET" },
  { no: 6202, name: "CHILIZ_SPICY" },
  { no: 6301, name: "ABSTRACT_MAINNET" },
  { no: 6302, name: "ABSTRACT_TESTNET" },
  { no: 6401, name: "K2_TESTNET" },
  { no: 6501, name: "METABASED_STRATOS" },
  { no: 6602, name: "MONAD_TESTNET" },
  { no: 6701, name: "SUPERSEED_MAINNET" },
  { no: 6702, name: "SUPERSEED_SEPOLIA" },
  { no: 6801, name: "DEGEN_MAINNET" },
  { no: 6802, name: "DEGEN_SEPOLIA" },
  { no: 6901, name: "UNITE_MAINNET" },
  { no: 6902, name: "UNITE_TESTNET" },
  { no: 7001, name: "SETTLUS_MAINNET" },
  { no: 7002, name: "SETTLUS_SEPTESTNET" },
  { no: 7101, name: "INK_MAINNET" },
  { no: 7102, name: "INK_SEPOLIA" },
  { no: 7201, name: "ODYSSEY_SEPOLIA" },
  { no: 7301, name: "RONIN_MAINNET" },
  { no: 7302, name: "RONIN_SAIGON" },
  { no: 7401, name: "STANDARD_MAINNET" },
  { no: 7402, name: "STANDARD_TESTNET" },
  { no: 7501, name: "METABASED2_EXO" },
  { no: 7601, name: "SYNDICATE_EXO" },
  { no: 7602, name: "SYNDICATE_MANCHEGO" },
  { no: 7701, name: "HUMANITY_MAINNET" },
  { no: 7702, name: "HUMANITY_TESTNET" },
  { no: 7801, name: "XPROTOCOL_MAINNET" },
  { no: 7802, name: "XPROTOCOL_SEPOLIA" },
  { no: 7901, name: "SPARKPOINT_MAINNET" },
  { no: 7902, name: "SPARKPOINT_TESTNET" },
  { no: 8001, name: "ALTERSCOPE_MAINNET" },
  { no: 8002, name: "ALTERSCOPE_SEPOLIA" },
  { no: 8101, name: "TEA_MAINNET" },
  { no: 8102, name: "TEA_SEPOLIA" },
  { no: 8201, name: "GENSYN_TESTNET" },
  { no: 8301, name: "OPENLOOT_SEPOLIA" },
  { no: 8402, name: "RISE_TESTNET" },
  { no: 8501, name: "BITCOIN_MAINNET" },
  { no: 8502, name: "BITCOIN_TESTNET" },
  { no: 8503, name: "BITCOIN_SIGNET" },
  { no: 8601, name: "MARS_TESTNET" },
  { no: 8701, name: "EARNM_SEPOLIA" },
  { no: 8801, name: "STORY_MAINNET" },
  { no: 8802, name: "STORY_AENEID" },
  { no: 8901, name: "WYLERCHAIN_SEPOLIA" },
  { no: 9002, name: "MEGAETH_TESTNET" },
  { no: 9101, name: "APTOS_MAINNET" },
  { no: 9102, name: "APTOS_TESTNET" },
  { no: 9201, name: "SUI_MAINNET" },
  { no: 9202, name: "SUI_TESTNET" },
  { no: 9302, name: "WORLDMOBILE_DEVNET" },
  { no: 9303, name: "WORLDMOBILE_TESTNET" },
  { no: 9402, name: "CONVERGE_TESTNET" },
  { no: 9502, name: "GALACTICA_CASSIOPEIA" },
  { no: 9602, name: "NEXUS_SEPOLIA" },
  { no: 9701, name: "BOTANIX_MAINNET" },
  { no: 9702, name: "BOTANIX_TESTNET" },
  { no: 9801, name: "WORLDMOBILECHAIN_MAINNET" },
  { no: 9901, name: "HYPERLIQUID_MAINNET" }
]);
var AppEnvironment = /* @__PURE__ */ ((AppEnvironment2) => {
  AppEnvironment2[AppEnvironment2["PRODUCTION"] = 0] = "PRODUCTION";
  AppEnvironment2[AppEnvironment2["DEVELOPMENT"] = 1] = "DEVELOPMENT";
  AppEnvironment2[AppEnvironment2["STAGING"] = 2] = "STAGING";
  return AppEnvironment2;
})(AppEnvironment || {});
import_protobuf.proto3.util.setEnumType(AppEnvironment, "alchemy.common.AppEnvironment", [
  { no: 0, name: "PRODUCTION" },
  { no: 1, name: "DEVELOPMENT" },
  { no: 2, name: "STAGING" }
]);
var NodeType = /* @__PURE__ */ ((NodeType2) => {
  NodeType2[NodeType2["NODE_TYPE_UNSPECIFIED"] = 0] = "NODE_TYPE_UNSPECIFIED";
  NodeType2[NodeType2["FULL"] = 1] = "FULL";
  NodeType2[NodeType2["ARCH"] = 2] = "ARCH";
  NodeType2[NodeType2["RETH_FULL"] = 5] = "RETH_FULL";
  NodeType2[NodeType2["RETH_ARCH"] = 6] = "RETH_ARCH";
  NodeType2[NodeType2["CRO_FULL"] = 100] = "CRO_FULL";
  NodeType2[NodeType2["FLOW_ACCESS"] = 200] = "FLOW_ACCESS";
  NodeType2[NodeType2["SOL_FULL"] = 300] = "SOL_FULL";
  NodeType2[NodeType2["SOL_INDEX"] = 301] = "SOL_INDEX";
  NodeType2[NodeType2["SOL_TOKENINDEX"] = 302] = "SOL_TOKENINDEX";
  return NodeType2;
})(NodeType || {});
import_protobuf.proto3.util.setEnumType(NodeType, "alchemy.common.NodeType", [
  { no: 0, name: "NODE_TYPE_UNSPECIFIED" },
  { no: 1, name: "FULL" },
  { no: 2, name: "ARCH" },
  { no: 5, name: "RETH_FULL" },
  { no: 6, name: "RETH_ARCH" },
  { no: 100, name: "CRO_FULL" },
  { no: 200, name: "FLOW_ACCESS" },
  { no: 300, name: "SOL_FULL" },
  { no: 301, name: "SOL_INDEX" },
  { no: 302, name: "SOL_TOKENINDEX" }
]);
var NodeImpl = /* @__PURE__ */ ((NodeImpl2) => {
  NodeImpl2[NodeImpl2["NODE_IMPL_UNSPECIFIED"] = 0] = "NODE_IMPL_UNSPECIFIED";
  NodeImpl2[NodeImpl2["GETH"] = 1] = "GETH";
  NodeImpl2[NodeImpl2["PARITY"] = 2] = "PARITY";
  NodeImpl2[NodeImpl2["ERIGON"] = 3] = "ERIGON";
  NodeImpl2[NodeImpl2["RETH"] = 4] = "RETH";
  NodeImpl2[NodeImpl2["ARB_CLASSIC"] = 201] = "ARB_CLASSIC";
  NodeImpl2[NodeImpl2["ARB_NITRO"] = 202] = "ARB_NITRO";
  return NodeImpl2;
})(NodeImpl || {});
import_protobuf.proto3.util.setEnumType(NodeImpl, "alchemy.common.NodeImpl", [
  { no: 0, name: "NODE_IMPL_UNSPECIFIED" },
  { no: 1, name: "GETH" },
  { no: 2, name: "PARITY" },
  { no: 3, name: "ERIGON" },
  { no: 4, name: "RETH" },
  { no: 201, name: "ARB_CLASSIC" },
  { no: 202, name: "ARB_NITRO" }
]);
var NodeState = /* @__PURE__ */ ((NodeState2) => {
  NodeState2[NodeState2["NODE_STATE_UNSPECIFIED"] = 0] = "NODE_STATE_UNSPECIFIED";
  NodeState2[NodeState2["READY"] = 1] = "READY";
  NodeState2[NodeState2["UNREACHABLE"] = 2] = "UNREACHABLE";
  NodeState2[NodeState2["NOT"] = 3] = "NOT";
  NodeState2[NodeState2["OUT"] = 4] = "OUT";
  NodeState2[NodeState2["ANSIBLE_UPGRADE"] = 5] = "ANSIBLE_UPGRADE";
  NodeState2[NodeState2["IN_MAINTENANCE"] = 6] = "IN_MAINTENANCE";
  return NodeState2;
})(NodeState || {});
import_protobuf.proto3.util.setEnumType(NodeState, "alchemy.common.NodeState", [
  { no: 0, name: "NODE_STATE_UNSPECIFIED" },
  { no: 1, name: "READY" },
  { no: 2, name: "UNREACHABLE" },
  { no: 3, name: "NOT" },
  { no: 4, name: "OUT" },
  { no: 5, name: "ANSIBLE_UPGRADE" },
  { no: 6, name: "IN_MAINTENANCE" }
]);
var SortDirection = /* @__PURE__ */ ((SortDirection2) => {
  SortDirection2[SortDirection2["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  SortDirection2[SortDirection2["ASC"] = 1] = "ASC";
  SortDirection2[SortDirection2["DESC"] = 2] = "DESC";
  return SortDirection2;
})(SortDirection || {});
import_protobuf.proto3.util.setEnumType(SortDirection, "alchemy.common.SortDirection", [
  { no: 0, name: "UNSPECIFIED" },
  { no: 1, name: "ASC" },
  { no: 2, name: "DESC" }
]);
var MoneyUnit = /* @__PURE__ */ ((MoneyUnit2) => {
  MoneyUnit2[MoneyUnit2["MONEY_UNIT_UNSPECIFIED"] = 0] = "MONEY_UNIT_UNSPECIFIED";
  MoneyUnit2[MoneyUnit2["FIAT_USD_DOLLAR"] = 1] = "FIAT_USD_DOLLAR";
  MoneyUnit2[MoneyUnit2["FIAT_USD_CENT"] = 2] = "FIAT_USD_CENT";
  MoneyUnit2[MoneyUnit2["CRYPTO_BTC_BITCOIN"] = 300] = "CRYPTO_BTC_BITCOIN";
  MoneyUnit2[MoneyUnit2["CRYPTO_BTC_SATOSHI"] = 301] = "CRYPTO_BTC_SATOSHI";
  MoneyUnit2[MoneyUnit2["CRYPTO_ETH_ETHER"] = 302] = "CRYPTO_ETH_ETHER";
  MoneyUnit2[MoneyUnit2["CRYPTO_ETH_GWEI"] = 303] = "CRYPTO_ETH_GWEI";
  MoneyUnit2[MoneyUnit2["CRYPTO_ETH_WEI"] = 304] = "CRYPTO_ETH_WEI";
  MoneyUnit2[MoneyUnit2["ALCHEMY_COMPUTE_UNIT"] = 1e3] = "ALCHEMY_COMPUTE_UNIT";
  MoneyUnit2[MoneyUnit2["ALCHEMY_SPONSORED_GAS"] = 1001] = "ALCHEMY_SPONSORED_GAS";
  return MoneyUnit2;
})(MoneyUnit || {});
import_protobuf.proto3.util.setEnumType(MoneyUnit, "alchemy.common.MoneyUnit", [
  { no: 0, name: "MONEY_UNIT_UNSPECIFIED" },
  { no: 1, name: "FIAT_USD_DOLLAR" },
  { no: 2, name: "FIAT_USD_CENT" },
  { no: 300, name: "CRYPTO_BTC_BITCOIN" },
  { no: 301, name: "CRYPTO_BTC_SATOSHI" },
  { no: 302, name: "CRYPTO_ETH_ETHER" },
  { no: 303, name: "CRYPTO_ETH_GWEI" },
  { no: 304, name: "CRYPTO_ETH_WEI" },
  { no: 1e3, name: "ALCHEMY_COMPUTE_UNIT" },
  { no: 1001, name: "ALCHEMY_SPONSORED_GAS" }
]);
const _ChainIdentifier = class _ChainIdentifier extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * Value should be all caps, alphanumeric chars only i.e. ETH, MATIC, etc
     *
     * @generated from field: string name = 1;
     */
    this.name = "";
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _ChainIdentifier().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _ChainIdentifier().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _ChainIdentifier().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_ChainIdentifier, a, b);
  }
};
_ChainIdentifier.runtime = import_protobuf.proto3;
_ChainIdentifier.typeName = "alchemy.common.ChainIdentifier";
_ChainIdentifier.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let ChainIdentifier = _ChainIdentifier;
const _NetworkIdentifier = class _NetworkIdentifier extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * Value should be all caps, alphanumeric chars only i.e. ETH_MAINNET, MATIC_MUMBAI, etc
     *
     * @generated from field: string name = 1;
     */
    this.name = "";
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _NetworkIdentifier().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _NetworkIdentifier().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _NetworkIdentifier().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_NetworkIdentifier, a, b);
  }
};
_NetworkIdentifier.runtime = import_protobuf.proto3;
_NetworkIdentifier.typeName = "alchemy.common.NetworkIdentifier";
_NetworkIdentifier.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let NetworkIdentifier = _NetworkIdentifier;
const _Money = class _Money extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * Amount in whichever unit is specified below
     *
     * @generated from field: double amount_in_unit = 1;
     */
    this.amountInUnit = 0;
    /**
     * @generated from field: alchemy.common.MoneyUnit unit = 2;
     */
    this.unit = 0 /* MONEY_UNIT_UNSPECIFIED */;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _Money().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _Money().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _Money().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_Money, a, b);
  }
};
_Money.runtime = import_protobuf.proto3;
_Money.typeName = "alchemy.common.Money";
_Money.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "amount_in_unit",
    kind: "scalar",
    T: 1
    /* ScalarType.DOUBLE */
  },
  { no: 2, name: "unit", kind: "enum", T: import_protobuf.proto3.getEnumType(MoneyUnit) }
]);
let Money = _Money;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppEnvironment,
  Chain,
  ChainIdentifier,
  CommitmentLevel,
  Money,
  MoneyUnit,
  Network,
  NetworkIdentifier,
  NodeImpl,
  NodeState,
  NodeType,
  SortDirection
});
